import styled, {css} from "styled-components";

export type Type = 'primary' | 'secondary' | 'external' | 'internal';

export const StyledButton = styled.a<{type: Type, isDisabled: boolean, isDynamicBtn: boolean}>`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 134px;
    height: 42px;
    padding: 8px;
    font-size: 16px;
    color: ${props => props.theme.palette.secondary.text};
    background-color: ${props => props.theme.palette.secondary.normal};
    text-decoration: none;
    border: solid 1px #000;
    border-radius: 21px;
    cursor: pointer;

    &:hover {
        color: #000;
        background-color: ${props => props.theme.palette.secondary.hover};
    }

    ${(props: {type: Type, isDisabled: boolean}) => props.type === 'primary' && css`
        border: none;
        color: ${props => props.theme.palette.primary.text};
        background-color: ${props => props.theme.palette.primary.normal};
        &:hover {
            color: #FFF;
            background-color: ${props => props.theme.palette.primary.hover};
        }
        
    `}

    ${(props: {type: Type}) => (props.type === 'internal' || props.type === 'external') && css`
        text-decoration: underline;
        border: none;
        color: ${props => props.theme.palette.primary.normal};
        background-color: transparent;
        &:hover {
            color: ${props => props.theme.palette.primary.normal};
            background-color: transparent;
        }
        &:visited {
            color: ${props => props.theme.palette.primary.hover};
        }
    `}
   
    ${(props: {isDisabled: boolean}) => props.isDisabled && css`
        opacity: .5;
        cursor: not-allowed;
        pointer-events: none;
    `}

    ${(props: {isDynamicBtn: boolean, type: Type})=> props.isDynamicBtn && css`
        ${(props.type === 'internal' || props.type === 'external')? `
        justify-content: left;
        padding-left: unset;
        width: fit-content;
        block-size: fit-content;
        &:hover {
          background-color: transparent;
        }`:``
        }
        
        @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
            width: 100%;
        } 
    `}

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        min-width: 170px;
        height: 56px;
        font-size: 18px;
        border-radius: 28px;
    }
`;
